export default __webpack_public_path__ + "static/media/office_web-md@2x.ee44b95b.webp";